module.exports = __webpack_public_path__ + "static/media/patient-icon.97aae93f.svg";